// extracted by mini-css-extract-plugin
export default {"check":"sT0u6"};